import React from 'react';
import styled from 'styled-components';
import Progress from '../../components/progress/Progress';
import Footer from '../../components/footer/Footer';
import Top from '../../components/top/Top';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SCardApplyLayout = styled.div(
  () => `
  display: flex;
  flex-direction: column;
  margin:0 auto;
  max-width: 1257px;
  min-height: 100vh;
  height: 100%;
  box-sizing: border-box;
  position: relative;
`,
);

const SCardApplyLayoutInner = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  max-width: 1080px;
  width: 100%;
  box-sizing: border-box;
  padding: ${theme.spacing.small}px 15px;
  margin: ${theme.spacing.small}px auto 0;
  @media only screen and ${theme.device.laptop} {
    margin-top: ${theme.spacing.larger}px;
  }
`,
);

const SCardApplyLayoutFooterInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;
`;

const SCommonSection = styled.section<{ showProgress?: boolean }>(({ theme, showProgress }) => `
  margin-bottom: ${theme.spacing.large}px;
  display: ${showProgress ? 'block' : 'none'};
`);

// tslint:enable:variable-name
// ############################ End Styles ###########################

interface ICardApplyLayoutProps {
  showProgress?: boolean;
  numberOfSteps: number;
  currentStep: number;
}

// tslint:disable-next-line:variable-name
const CardApplyLayout: React.FC<ICardApplyLayoutProps> = (props) => (
  <SCardApplyLayout>
    <Top />
    <SCardApplyLayoutInner>
      <SCommonSection showProgress={props.showProgress}>
        <Progress dataAt="cardApplyProgress" numberOfSteps={props.numberOfSteps} currentStep={props.currentStep} />
      </SCommonSection>
      {props.children}
    </SCardApplyLayoutInner>
    <SCardApplyLayoutFooterInner>
      <Footer />
    </SCardApplyLayoutFooterInner>
  </SCardApplyLayout>
);

export default CardApplyLayout;
